/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { schemeLocationChangeImpactSchema } from './schemeLocationChangeImpactSchema';

export const pageResponseSchemeLocationChangeImpactSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(schemeLocationChangeImpactSchema);
  },
  hasNextPage: z.boolean().nullish(),
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
